const Style = {
  div: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  nav: {
    height: "10%",
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
  },
  attachments: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start;",
    gap: "5px",
    color: "red",
  },
  attachmentsLists: {
    background: "#f5f5f5",
  },
  attachmentsListsItems: {
    display: "flex",
    alignItems: "center",
    color: "#15c",
  },
  tableTitle: {
    color: "rgb(97, 97, 97)",
    fontSize: "1.2rem",
    fontWeight: 500,
    marginBottom: "20px",
  },
  noteText: {
    width: "50%",
    margin: "0 auto 50px auto",
  },
  redAsterisk: {
    color: "red",
  },
};
export default Style;
